function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.41663 0V3.66667H22V0H6.41663ZM6.41663 11H22V7.33333H6.41663V11ZM6.41663 18.3333H22V14.6667H6.41663V18.3333Z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 18.3333H3.66667V14.6667H0V18.3333Z",
  fill: "#fff",
  fillOpacity: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 7.33333H3.66667V11H0V7.33333Z",
  fill: "#fff",
  fillOpacity: 0.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H3.66667V3.66667H0V0Z",
  fill: "#fff",
  fillOpacity: 0.5
});

function SvgToggleWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleWhite);
export default __webpack_public_path__ + "static/media/toggleWhite.b9ad46c1.svg";
export { ForwardRef as ReactComponent };